import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Checkbox,
  FormControlLabel,
  FormGroup,
  MenuItem,
  LinearProgress,
  Menu,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch, useDelete, useUpdate } from "../../hooks";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

export default function AdminRole({ onBack }) {
  const [search, setSearch] = useState("");
  const [roleNameError, setRoleNameError] = useState("");
  const [checkboxError, setCheckboxError] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [roleName, setRoleName] = useState("");
  const [accessLevels, setAccessLevels] = useState({
    allAccess: false,
    dashboardAccess: false,
    productAccess: false,
    vendorAccess: false,
    orderAccess: false,
    customerAccess: false,
    deliveryAccess: false,
    analyticsAccess: false,
    financialAccess: false,
    marketingAccess: false,
    settingAccess: false,
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [data, setData] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isEditMode, setEditMode] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    message: "",
    status: "",
  });
  const loginToken = useSelector((state) => state.user.logintoken);
  console.log("loginToken", loginToken);

  useEffect(() => {
    fetchData();
  }, []);

  const {
    data: allRolesData,
    isLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllRoles"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  const {
    data: createRolesData,
    isLoading: createRolesLoading,
    error: createRolesError,
    fetchData: fetchCreateData,
  } = useFetch(BASE_URL_TEST + urls("createRoles"), {
    method: "POST",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: updateRolesData,
    isLoading: updateRolesLoading,
    error: updateRolesError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: deleteRolesData,
    isLoading: deleteRolesLoading,
    error: deleteRolesError,
    deleteData: fetchDeleteData,
  } = useDelete(BASE_URL_TEST, {
    method: "DELETE",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  //Fetching All Roles
  useEffect(() => {
    if (error) {
    } else if (allRolesData && allRolesData["status"] === true) {
      setData(allRolesData["data"]);
    }
  }, [allRolesData, error]);

  //Create Roles
  useEffect(() => {
    if (createRolesError) {
    } else if (createRolesData && createRolesData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: createRolesData["message"],
        status: createRolesData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (createRolesData && createRolesData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: createRolesData["message"],
        status: createRolesData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [createRolesData, createRolesError]);

  //Update Roles
  useEffect(() => {
    if (updateRolesError) {
    } else if (updateRolesData && updateRolesData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: updateRolesData["message"],
        status: updateRolesData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (updateRolesData && updateRolesData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: updateRolesData["message"],
        status: updateRolesData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [updateRolesData, updateRolesError]);

  //Delete Roles
  useEffect(() => {
    if (deleteRolesError) {
    } else if (deleteRolesData && deleteRolesData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: deleteRolesData["message"],
        status: deleteRolesData["status"],
      });
      setDeleteModalOpen(true);
      fetchData();
    } else if (deleteRolesData && deleteRolesData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: deleteRolesData["message"],
        status: deleteRolesData["status"],
      });
      setDeleteModalOpen(true);
      fetchData();
    }
  }, [deleteRolesData, deleteRolesError]);

  const handleMenuOpen = (event, userId) => {
    setAnchorEl(event.currentTarget);
    setSelectedUserId(userId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedUserId(null);
  };
  //Edit the user
  const handleEdit = (user) => {
    setSelectedUser(user);
    setEditMode(true);
    setOpenDialog(true);
    setRoleName(user.role_name);
    setAccessLevels({
      allAccess: false,
      dashboardAccess: user.role_permissions.dashboard_management || false,
      productAccess: user.role_permissions.product_management || false,
      vendorAccess: user.role_permissions.vendor_management || false,
      orderAccess: user.role_permissions.order_management || false,
      customerAccess: user.role_permissions.customer_management || false,
      deliveryAccess: user.role_permissions.delivery_staff_management || false,
      analyticsAccess: user.role_permissions.analytics || false,
      financialAccess: user.role_permissions.financial_management || false,
      marketingAccess: user.role_permissions.marketing_and_promotions || false,
      settingAccess: user.role_permissions.system_management || false,
    });
  };

  // Handle delete action
  const handleDelete = (roleId) => {
    const deleteUrl = urls("deleteRoles", roleId);
    setModalOpen(true);
    fetchDeleteData(deleteUrl);
  };

  //Checkbox change
  const handleCheckboxChange = (field) => {
    if (field === "allAccess") {
      const newValue = !accessLevels.allAccess;
      setAccessLevels({
        allAccess: newValue,
        dashboardAccess: newValue,
        productAccess: newValue,
        vendorAccess: newValue,
        orderAccess: newValue,
        customerAccess: newValue,
        deliveryAccess: newValue,
        analyticsAccess: newValue,
        financialAccess: newValue,
        marketingAccess: newValue,
        settingAccess: newValue,
      });
    } else {
      setAccessLevels((prev) => {
        const updatedAccessLevels = { ...prev, [field]: !prev[field] };
        const allSelected = Object.values(updatedAccessLevels).every(
          (value) => value === true
        );
        return {
          ...updatedAccessLevels,
          allAccess: allSelected,
        };
      });
    }
  };
  //Reset button handle
  const handleReset = () => {
    setRoleName("");
    setRoleNameError("");
    setCheckboxError("");
    setAccessLevels({
      allAccess: false,
      dashboardAccess: false,
      productAccess: false,
      vendorAccess: false,
      orderAccess: false,
      customerAccess: false,
      deliveryAccess: false,
      analyticsAccess: false,
      financialAccess: false,
      marketingAccess: false,
      settingAccess: false,
    });
  };

  //Handle Submit action
  const handleSubmit = () => {
    const data = { roleName, accessLevels };

    if (!roleName.trim()) {
      setRoleNameError("Role name is required");
      return;
    }

    if (roleName && !Object.values(accessLevels).some((value) => value)) {
      setRoleNameError("");
      setCheckboxError("At least one permission must be selected");
      return;
    }

    const saveBody = {
      role_name: roleName,
      role_permissions: {
        dashboard_management: accessLevels.dashboardAccess,
        product_management: accessLevels.productAccess,
        vendor_management: accessLevels.vendorAccess,
        order_management: accessLevels.orderAccess,
        customer_management: accessLevels.customerAccess,
        delivery_staff_management: accessLevels.deliveryAccess,
        analytics: accessLevels.analyticsAccess,
        financial_management: accessLevels.financialAccess,
        marketing_and_promotions: accessLevels.marketingAccess,
        user_management: false,
        system_management: accessLevels.settingAccess,
      },
    };
    if (isEditMode) {
      const updateUrl = urls("updateRoles", selectedUser["role_id"]);
      fetchUpdateData(updateUrl, saveBody);
    } else {
      fetchCreateData(saveBody);
    }
  };
  //For open the Create or Edit Role Modal
  const handleOpenCreateModal = (user) => {
    setEditMode(false);
    setSelectedUser(user);
    setOpenDialog(true);
    setRoleName("");
    setRoleNameError("");
    setCheckboxError("");
    setAccessLevels({
      allAccess: false,
      dashboardAccess: false,
      productAccess: false,
      vendorAccess: false,
      orderAccess: false,
      customerAccess: false,
      deliveryAccess: false,
      analyticsAccess: false,
      financialAccess: false,
      marketingAccess: false,
      settingAccess: false,
    });
  };

  //Close the dialog
  const handleClose = () => {
    setOpenDialog(false);
    setModalOpen(false);
    setDeleteModalOpen(false);
    setRoleName("");
    setRoleNameError("");
    setCheckboxError("");
    if (createRolesData && createRolesData["status"] === true) {
      setAccessLevels({
        allAccess: false,
        dashboardAccess: false,
        productAccess: false,
        vendorAccess: false,
        orderAccess: false,
        customerAccess: false,
        deliveryAccess: false,
        analyticsAccess: false,
        financialAccess: false,
        marketingAccess: false,
        settingAccess: false,
      });
    }
    if (isEditMode) {
      if (updateRolesData && updateRolesData["status"] === true) {
        setAccessLevels({
          allAccess: false,
          dashboardAccess: false,
          productAccess: false,
          vendorAccess: false,
          orderAccess: false,
          customerAccess: false,
          deliveryAccess: false,
          analyticsAccess: false,
          financialAccess: false,
          marketingAccess: false,
          settingAccess: false,
        });
      }
    }
    setSnackbarState({
      message: "",
      status: "",
    });
  };

  // Handle search
  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  const filteredData =
    data && data.length > 0
      ? data
          .sort((a, b) => b.role_id - a.role_id) // Sort by ID in descending order, latest ID first
          .filter(
            (item) =>
              (item.role_id &&
                item.role_id
                  .toString()
                  .toLowerCase()
                  .includes(search.toLowerCase())) ||
              (item.role_name &&
                item.role_name.toLowerCase().includes(search.toLowerCase()))
          )
      : data;

  return (
    <Box
      sx={{
        bgcolor: "white",
        p: 2,
      }}
    >
      <Box
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            mt={2}
          >
            <TextField
              variant="outlined"
              placeholder="Search"
              size="small"
              value={search}
              onChange={handleSearch}
              sx={{
                width: "30%",
                backgroundColor: "#FFF",
                borderRadius: 1,
              }}
            />

            <Button
              variant="contained"
              startIcon={<AddCircleOutlineIcon />}
              onClick={() => handleOpenCreateModal()}
              sx={{ bgcolor: "#00796b", "&:hover": { bgcolor: "#005a4f" } }}
            >
              Add
            </Button>
          </Box>
          {/* Table Section */}
          <TableContainer component={Paper} sx={{ mt: 3 }}>
            <Table>
              <TableHead sx={{ backgroundColor: "#00796b" }}>
                <TableRow>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Role Id
                  </TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Role Name
                  </TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Access
                  </TableCell>

                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      <Typography>No records found</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredData.map((user) => {
                    const { role_permissions } = user;
                    const permissions = Object.keys(role_permissions)
                      .filter((key) => role_permissions[key])
                      .map((key) =>
                        key
                          .replace(/_/g, " ")
                          .toLowerCase()
                          .replace(/^\w/, (c) => c.toUpperCase())
                      )
                      .join(", ");

                    return (
                      <TableRow key={user.id}>
                        <TableCell>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Typography>{user.role_id}</Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Avatar sx={{ bgcolor: "#00796b", mr: 2 }}>
                              {user.role_name.charAt(0)}
                            </Avatar>
                            <Typography>{user.role_name}</Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          {permissions ? permissions : "No Access"}
                        </TableCell>
                        <TableCell>
                          <IconButton
                            onClick={(e) =>
                              handleMenuOpen(e, user.role_id, permissions)
                            }
                          >
                            <MoreVertIcon />
                          </IconButton>
                          <Menu
                            anchorEl={anchorEl}
                            open={
                              Boolean(anchorEl) &&
                              selectedUserId === user.role_id
                            }
                            onClose={handleMenuClose}
                          >
                            {/* <MenuItem onClick={() => handleEdit(user)}>
                              Edit
                            </MenuItem> */}
                            <MenuItem
                              onClick={() => handleDelete(user.role_id)}
                            >
                              Delete
                            </MenuItem>
                          </Menu>
                        </TableCell>
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Dialog
          open={isDeleteModalOpen}
          onClose={() => setDeleteModalOpen(false)}
        >
          <DialogTitle>
            {snackbarState.status === true ? "Success" : "Error"}
          </DialogTitle>
          <DialogContent>
            <Typography
              variant="body1"
              sx={{
                color: snackbarState.status === true ? "green" : "red",
              }}
            >
              {snackbarState.message}
            </Typography>
          </DialogContent>
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleClose}
              sx={{
                textTransform: "none",
                borderRadius: 2,
                alignSelf: "center",
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog for Editing User */}
        <Dialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          maxWidth="xl"
          fullWidth
        >
          <DialogTitle>
            <Typography variant="h6" mb={2}>
              {isEditMode ? "Edit Role" : "Create Role"}
            </Typography>
            <IconButton
              aria-label="close"
              onClick={() => setOpenDialog(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            {/* Role setup */}
            <Box
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                padding: 4,
                maxWidth: 1200,
                margin: "auto",
                backgroundColor: "#fff",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Typography variant="h6" sx={{ marginBottom: 2 }}>
                Roles Setup
              </Typography>

              <TextField
                fullWidth
                label="Role Name"
                value={roleName}
                onChange={(e) => setRoleName(e.target.value)}
                error={!!roleNameError}
                helperText={
                  roleNameError && (
                    <Typography
                      sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                    >
                      {roleNameError}
                    </Typography>
                  )
                }
                sx={{ marginBottom: 3 }}
              />

              <Box sx={{ display: "flex", gap: 2 }}>
                <Typography sx={{ mt: 1 }}>Permissions/Access</Typography>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={accessLevels.allAccess}
                        onChange={() => handleCheckboxChange("allAccess")}
                      />
                    }
                    label="Select All"
                  />
                </FormGroup>
              </Box>
              <Box>
                <Typography sx={{ fontWeight: "bold" }}>
                  Select the option you want to give access to this role
                </Typography>
              </Box>
              <Box sx={{ display: "flex", gap: 2 }}>
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={accessLevels.dashboardAccess}
                        onChange={() => handleCheckboxChange("dashboardAccess")}
                      />
                    }
                    label="Dashboard Management"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={accessLevels.productAccess}
                        onChange={() => handleCheckboxChange("productAccess")}
                      />
                    }
                    label="Product Management"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={accessLevels.vendorAccess}
                        onChange={() => handleCheckboxChange("vendorAccess")}
                      />
                    }
                    label="Vendor Management"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={accessLevels.orderAccess}
                        onChange={() => handleCheckboxChange("orderAccess")}
                      />
                    }
                    label="Order Management"
                  />
                </FormGroup>
              </Box>
              <Box sx={{ display: "flex", gap: 2 }}>
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={accessLevels.customerAccess}
                        onChange={() => handleCheckboxChange("customerAccess")}
                      />
                    }
                    label="Customer Management"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={accessLevels.deliveryAccess}
                        onChange={() => handleCheckboxChange("deliveryAccess")}
                      />
                    }
                    label="Delivery Management"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={accessLevels.analyticsAccess}
                        onChange={() => handleCheckboxChange("analyticsAccess")}
                      />
                    }
                    label="Analytics"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={accessLevels.financialAccess}
                        onChange={() => handleCheckboxChange("financialAccess")}
                      />
                    }
                    label="Financial Management"
                  />
                </FormGroup>
              </Box>
              <Box sx={{ display: "flex", gap: 2 }}>
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={accessLevels.marketingAccess}
                        onChange={() => handleCheckboxChange("marketingAccess")}
                      />
                    }
                    label="Marketing & Promotions"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={accessLevels.settingAccess}
                        onChange={() => handleCheckboxChange("settingAccess")}
                      />
                    }
                    label="Setting & Confiuration"
                  />
                </FormGroup>
              </Box>
              {checkboxError && (
                <Typography
                  sx={{ color: "red", textAlign: "left", marginTop: 1 }}
                >
                  {checkboxError}
                </Typography>
              )}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 4,
                  gap: 2,
                }}
              >
                {!isEditMode && (
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleReset}
                    sx={{
                      textTransform: "none",
                      borderRadius: 2,
                    }}
                  >
                    Reset
                  </Button>
                )}
                <Button
                  variant="contained"
                  color="success"
                  onClick={handleSubmit}
                  sx={{
                    textTransform: "none",
                    borderRadius: 2,
                  }}
                >
                  Submit
                </Button>
              </Box>
            </Box>
          </DialogContent>
          <Dialog open={isModalOpen} onClose={() => setModalOpen(false)}>
            <DialogTitle>
              {snackbarState.status === true ? "Success" : "Error"}
            </DialogTitle>
            <DialogContent>
              <Typography
                variant="body1"
                sx={{
                  color: snackbarState.status === true ? "green" : "red",
                }}
              >
                {snackbarState.status === true
                  ? snackbarState.message
                  : createRolesError || updateRolesError || deleteRolesError}
              </Typography>
            </DialogContent>
            <DialogActions
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={handleClose}
                sx={{
                  textTransform: "none",
                  borderRadius: 2,
                  alignSelf: "center",
                }}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </Dialog>
      </Box>
    </Box>
  );
}
